var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.000004,
    id: "svg7637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-264.49968,-565.90983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-973.96663,390.18555)",
    style: {
      display: "inline"
    },
    id: "g22182"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.00100005,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    },
    id: "rect22115",
    width: 14,
    height: 13,
    x: 1238.4663,
    y: 175.72427,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11210",
    d: "m 1245.4349,175.72428 c -2.1171,0 -3.8402,1.72313 -3.8402,3.8402 0,2.11707 1.7231,3.84019 3.8402,3.84019 2.1171,0 3.8402,-1.72311 3.8402,-3.84019 0,-2.11708 -1.7231,-3.8402 -3.8402,-3.8402 z m -3.6199,7.46005 c -1.0703,0.21794 -1.8572,1.16113 -1.8571,2.29782 l 0,3.24213 11.0169,0 0,-3.24213 c 10e-5,-1.13669 -0.7866,-2.07988 -1.8571,-2.29782 -0.8489,1.07827 -2.1735,1.79419 -3.6514,1.79419 -1.4776,0 -2.7711,-0.71592 -3.6198,-1.79419 -0.01,-0.007 -0.026,0.007 -0.032,0 l 5e-4,0 0,0 0,0 z",
    style: {
      fill: "#999999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.4000001,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.32d569ff55f1d0d32692183dc4aa3b93.svg";
export { ForwardRef as ReactComponent };